import { useApp } from 'store/steps'
import { useListOpeningHoursQuery } from 'store/api-slice/hooks'
import OpeningHoursDesktop from './components/OpeningHoursDesktop'
import OpeningHoursMobile from './components/OpeningHoursMobile'
import Loader from 'components/shared/Loader'
import { useResolutions } from 'store/resolutions'

const OpeningHours = () => {
    const { language } = useApp()
    const { data, isFetching } = useListOpeningHoursQuery({ _locale: language })
    const seasons = data?.items || []

    const filteredAttractions = seasons.map(({ attractions }) => {
        if (!attractions) return []

        type combinedHoursTypes = {
            spa?: string[]
            spaAndWellness?: string[]
        }

        const combinedHours: combinedHoursTypes = {}

        combinedHours.spa = attractions
            .filter((attraction) => attraction.attractionKey === 'spa')
            .map((data) => data?.hours || [])
            .flat()

        combinedHours.spaAndWellness = attractions
            .filter(
                (attraction) => attraction.attractionKey === 'wellness_and_spa'
            )
            .map((data) => data?.hours || [])
            .flat()

        //TODO: refactor when design for spa & wellness display is ready
        if (combinedHours.spa?.length) {
            return combinedHours.spa
        } else if (
            !combinedHours.spa?.length &&
            combinedHours.spaAndWellness?.length
        ) {
            return combinedHours.spaAndWellness
        } else {
            return []
        }
    })

    const { isTablet } = useResolutions()
    const getOpeningHoursByResolution = !isTablet ? (
        <OpeningHoursDesktop data={seasons} hours={filteredAttractions} />
    ) : (
        <OpeningHoursMobile data={seasons} hours={filteredAttractions} />
    )

    return isFetching ? (
        <Loader pt={[22, 42]} pb={[22, 42]} justify="center" align="center" />
    ) : (
        getOpeningHoursByResolution
    )
}

export default OpeningHours
